import moment from 'moment'

function timeShowingText(t, suffix, defaultText = "") {
  if(t > 0) {
    return t + " " + suffix
  }

  return defaultText
}

function getTimesFromNowText(timestamp, basedTimstamp) {
  if(!basedTimstamp) {
    basedTimstamp = responseTime()
  }

  let targetTime  = moment(timestamp)

  let duration = moment.duration(basedTimstamp.unix() - targetTime.unix(), "seconds")

  let months = duration.months()
  let days = duration.days()
  let hours = duration.hours()
  let minutes = duration.minutes()
  let seconds = duration.seconds()

  let totalSeconds = duration.asSeconds()

  let timeText = ""

  if(months > 0) {
    timeText = basedTimstamp.format("MM-DD HH:mm")
  } else {
    timeText += timeShowingText(days, "day ")
    timeText += timeShowingText(hours, "hour ")
    timeText += timeShowingText(minutes, "min ")
    if (totalSeconds < 60 * 60) {
      timeText += timeShowingText(seconds, "sec ")
    }
    timeText += "ago "
  }

  return timeText
}

function responseTime(timestamp) {
  let resTime = moment()
  if(timestamp) {
    resTime = moment(timestamp)
  } else {
    let utcOffset = resTime.utcOffset()
    resTime = resTime.add(8 * 60 - utcOffset, "minutes")
  }

  return resTime
}

let nknTimes = {
  getTimesFromNowText,
  responseTime,
}

export {
  nknTimes
}


// WEBPACK FOOTER //
// ./src/tasks/nknTimes.js